import {
  VenueListReservationsContentFilter,
  VenueReservationContentCountResponse,
} from '../../graphql/API';
import { venueGetReservationContentCount } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const venueGetReservationContentCountApi = async (
  filter: Partial<VenueListReservationsContentFilter>,
): Promise<VenueReservationContentCountResponse> => {
  const result = await executeGql<VenueReservationContentCountResponse>(
    venueGetReservationContentCount,
    { filter },
  );
  return processGqlResult<VenueReservationContentCountResponse>(
    'venueGetReservationContentCount',
    result,
  );
};
